import React from 'react';
import PropTypes from 'prop-types';
import { AlertLevelCell } from 'smartsuite-ui/lib/alerts/AlertLevelCell';
import useLink from '../../../../shared/hooks/linkHooks';

// eslint-disable-next-line complexity
export default function ColorCell(props) {
    const linkUri = useLink(
        props.columnConfig.linkConfig,
        props.metricRequest,
        props.resultRow
    );

    function renderCellContent() {
        return linkUri ? (
            <a
                href={linkUri}
                target={props.openLinksInNewTab ? '_blank' : ''}
                rel="noreferrer"
            >
                {props.value}
            </a>
        ) : (
            <span>{props.value}</span>
        );
    }

    return (
        <AlertLevelCell
            alertLevelId={props.resultRow[props.columnConfig.stateDataKey]}
            cssClassModifiers={[props.isLeftAligned ? 'left-align' : '']}
        >
            {renderCellContent()}
        </AlertLevelCell>
    );
}

ColorCell.propTypes = {
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    isLeftAligned: PropTypes.bool,
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    resultRow: PropTypes.instanceOf(Object),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
